enum ProductTypeDto {
    Gaming = 'gaming',
    Sportsbook = 'sportsbook',
    Virtuals = 'virtuals',
    Lotto = 'lotto',
    Honey = 'honey',
}

export default ProductTypeDto;
